import ModalBody from '../../shared/components/ModalBody';
import { Button, notification } from 'antd';
import Modal from '../../shared/components/Modal';
import React, { useState } from 'react';
import { getStripeUrl } from '../../redux/actions/eCommerceActions';

export const UpgradeModal = ({ show, onHide }) => {
  const [fetchingUpgradeLink, setFetchingUpgradeLink] = useState(false);

  const handleUpgradeClick = () => {
    setFetchingUpgradeLink(true);
    getStripeUrl()
      .then((request) => {
        window.location.href = request.url;
      })
      .catch((e) => {
        notification.error({
          key: 'response.id',
          message: 'Error occurred',
          description: e.message,
        });
      })
      .finally(() => {
        setFetchingUpgradeLink(false);
        if (onHide) onHide();
      });
  };

  return (
    <Modal
      onHide={onHide}
      show={show}
      title={'Upgrade Your Monitoring'}>
      <ModalBody>
        <div style={{ textAlign: 'center', padding: '10px' }}>
          <div style={{ fontSize: '70px', marginBottom: '20px', color: '#06abc1' }}>🚀</div>
          <h2 style={{ fontWeight: 'bold', marginBottom: '15px' }}>
            Ready to take your monitoring to the next level?
          </h2>
          <div
            style={{
              fontSize: '16px',
              marginBottom: '25px',
              textAlign: 'left',
              margin: '0 auto',
            }}>
            <ul style={{ listStyleType: 'none', padding: '0' }}>
              {[
                {
                  icon: '⏱️',
                  label: 'Faster Monitoring',
                  desc: 'Check as frequently as every minute',
                },
                {
                  icon: '🔌',
                  label: 'Advanced HTTP',
                  desc: 'PUT/POST/DELETE requests & configurations',
                },
                {
                  icon: '🌐',
                  label: 'DNS Monitoring',
                  desc: 'Track domain registry expiration dates',
                },
                {
                  icon: '🗺️',
                  label: 'Global Coverage',
                  desc: 'Monitor from multiple geographic locations',
                },
                {
                  icon: '🛡️',
                  label: 'Redundancy Controls',
                  desc: 'Configure minimum healthy regions',
                },
                { icon: '🔑', label: 'API Access', desc: 'Integrate with your existing systems' },
                { icon: '👥', label: 'Team Access', desc: 'Add multiple user accounts' },
                { icon: '📱', label: 'SMS Alerts', desc: 'Get critical notifications via text' },
              ].map((feature, i) => (
                <li
                  key={i}
                  style={{
                    marginBottom: '8px',
                    display: 'flex',
                    alignItems: 'flex-start',
                  }}>
                  <span
                    style={{
                      marginRight: '10px',
                      fontSize: '18px',
                      display: 'inline-block',
                      width: '25px',
                    }}>
                    {feature.icon}
                  </span>
                  <div>
                    <span style={{ fontWeight: 'bold', color: '#06abc1' }}>{feature.label}</span>
                    <span
                      style={{
                        color: '#666',
                        marginLeft: '5px',
                        fontSize: '14px',
                      }}>
                      — {feature.desc}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <Button
            type="primary"
            size="large"
            style={{
              background: '#06abc1',
              borderColor: '#06abc1',
              width: '80%',
              height: '48px',
              fontSize: '16px',
              fontWeight: 'bold',
            }}
            loading={fetchingUpgradeLink}
            onClick={handleUpgradeClick}>
            Upgrade Now
          </Button>
          <div style={{ marginTop: '15px' }}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (onHide) onHide();
              }}>
              Continue with Current Plan
            </a>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
